import { useCallback } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import VeloxPopupTemplate from "../../common/VeloxPopupTemplate";
import { closeDialog } from "../../../store/actionCreators/dialogManager";
import { exitFullScreenMode } from "../../../helpers/fullScreen";
import { resetTournamentGameUrl } from "../../../store/actionCreators/tournamentGameUrl";
import { resetToggleJackpotGameFromHost } from "../../../store/actionCreators/toggleJackpotGameFromHost";
import { casinoTournamentPlayersRequest } from "../../../store/actionCreators/casinoTournamentPlayers";
import { resetCasinoTournament } from "../../../store/actionCreators/casinoTournament";
import {
    getCasinoTournament,
    getCasinoTournamentPlayers,
    getTournamentPlayers
} from "../../../store/selectors";

const VeloxForceCloseGame = ({ tournamentId }) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const tournament = useSelector(getCasinoTournament);
  const playersFromSocket = useSelector(getTournamentPlayers)?.(tournament?.tournamentId);
  const playersFromAPI = useSelector(getCasinoTournamentPlayers)?.(tournament?.tournamentId);
  const players = playersFromSocket || playersFromAPI;
  const self = players?.find((item) => item.self);
  const veloxForceCloseText =
      self?.spins > 0
          ? t('veloxCloseGameSpinsWarning', { count: self?.spins })
          : self?.spins === 0
          ? t('veloxCloseGameSpinsInfo')
          : t('veloxForceCloseGameDialogTitle');

  const onClose = useCallback(
    () => dispatch(closeDialog("veloxForceCloseGame")),
    [dispatch]
  );

  const onConfirm = useCallback(
    () => {
      exitFullScreenMode();
      dispatch(resetTournamentGameUrl());
      dispatch(resetToggleJackpotGameFromHost(false));
      dispatch(casinoTournamentPlayersRequest({ id: tournamentId, offset: 0, limit: 20 }));
      dispatch(resetCasinoTournament());
      dispatch(closeDialog("jackpotTournamentFinished"));
      dispatch(closeDialog("tournamentFinished"));
      onClose();
    },
    [dispatch]
  );

  return (
    <VeloxPopupTemplate
      className="velox-force-close-game-dialog"
      title={veloxForceCloseText}
      onClose={onClose}
      onConfirm={onConfirm}
      confirmText={t("yes")}
    />
  );
};

export default VeloxForceCloseGame;
